e4.download = {
    init: function () {
        if ( jQuery( '.js-e-download-cart-form' ).length === 1 ) {
            e4.download.cart.init();
            //e4.ecom.product.bindEvents();
        }
        else if ( jQuery( '.js-e-download-cart-quantity' ).length > 0 ) {
            e4.download.event = e4.util.registerEvents( 'add added', 'download' );
            //e4.download.cart.updateQuantity();
        }
        else {
            e4.download.event = e4.util.registerEvents( 'add added', 'download' );
        }
        if ( jQuery( '.js-e-productlist-download' ).length > 0 ) {
            e4.download.list.init();

            jQuery('.js-e-productlist-download').on('submit', '.js-e-product-form', function(event){
                event.preventDefault();
                if ( jQuery(event.target).is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( event.target );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( event.target );
                }

            });
        }
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.download.url,
            method: 'POST',
            dataType: 'json',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } );
    },
    list: {
        init: function () {
            e4.download.list.bindEvents();
            e4.download.list.toogleIsInCart();
        },
        bindEvents: function () {
            //jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', e4.download.list.toogleIsInCart );
            jQuery( document  ).on( 'submit', '.js-e-download-search-form', function ( event ) {
                event.preventDefault();
                var jForm            = jQuery( event.target ),
                    jProductlistForm = jQuery( '.js-e-productlist-form' );
                jProductlistForm.find( '.js-e-search-input' ).val( jForm.find( '.js-e-search-input' ).val() );
                jProductlistForm.trigger( 'submit' );
                return false;
            } );
            jQuery( '.js-e-download-addall' ).on( 'click', e4.download.list.addAll );
        },
        addAll: function () {
            var objFormData       = {},
                domElmOverlay = document.querySelector( '.js-e-productlist-loading-overlay' );
            domElmOverlay.classList.add( 'is-loading' );

            jQuery('input[name="PageSize"]').val(999);
            jQuery('input[name="PageNum"]').val(1);

            jQuery.ajax({
                url: e4.settings.ecom.products.url,
                data: e4.productlist.getParamsFromForm()
            }).done(function(jsonData){

                jQuery.each(jsonData.products, function(index, objProduct){
                    objFormData[ 'ProductLoopCounter' + index ] = index;
                    objFormData[ 'ProductID' + index ] = objProduct.id;
                    objFormData[ 'VariantID' + index ] = objProduct.variantId;
                    objFormData[ 'Quantity' + index ] = 1;
                    jQuery( '.js-e-products-item-' + objProduct.id ).addClass( 'is-in-cart' );
                });

                e4.download.cart.addMultipleProducts( objFormData, () => {
                    domElmOverlay.classList.remove( 'is-loading' );
                } );
            });

        },
        toogleIsInCart: function () {
            e4.download.ajax( {
                method: 'GET'
            }, function ( data ) {
                jQuery.each( data.cart.orderlines, function ( index, value ) {
                    if(value.product !== null){
                        jQuery( '.js-e-products-item-' + value.product.id ).addClass( 'is-in-cart' );
                    }

                } );
            } );
        }
    },
    cart: {
        init: function () {
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-orderlines #js-e-handlebars-tmpl-cart-summery' );
                e4.download.event = e4.util.registerEvents( 'load loaded add added update updated', 'download' );
                e4.download.cart.bindEvents();
                e4.download.orderline.init();
                e4.download.cart.load();
            } );
        },
        bindEvents: function () {
            jQuery( '.js-e-download-cart-email-add-btn' ).on( 'click', e4.download.cart.addEmail );
            jQuery('.js-identity-clear-download-cart').on('click', function(){
                jQuery.ajax({
                    url: location.href,
                    method: 'GET',
                    data: {
                        CartCmd: 'emptyCart',
                        OrderContext: 'ORDERCONTEXT1',
                        Redirect: false
                    }
                }).done(function () {
                    location.reload();
                });
            });
        },
        load: function () {
            var jDownloadCart = jQuery( '.js-e-download-cart' );
            jDownloadCart.trigger( e4.download.event.load );
            e4.download.ajax( {
                method: 'GET',
                beforeSend: function () {
                    jDownloadCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                }
            }, function ( data ) {
                e4.download.cart.update( data );
                jDownloadCart.trigger( e4.download.event.loaded );
            } );
        },
        addProduct: function ( strObjProduct, fnCallback ) {
            var jDownloadCart = jQuery( '.js-e-download-cart' );
            jDownloadCart.trigger( e4.download.event.add );
            var objProductData = {
                OrderContext: 'ORDERCONTEXT1',
                CartCmd: 'add',
                ProductID: '',
                VariantID: '',
                Quantity: 1,
                Redirect: false
            };
            if ( jQuery.isPlainObject( strObjProduct ) === true ) {
                jQuery.extend( objProductData, strObjProduct );
            }
            else if ( jQuery.type( strObjProduct ) === 'string' ) {
                objProductData.ProductID = strObjProduct;
            }
            //if ( objProductData.ProductID.indexOf( 'PROD' ) === 0 ) {
                e4.download.ajax( {
                    data: objProductData,
                    beforeSend: function () {
                        var jDownloadCart = jQuery( '.js-e-download-cart' );
                        if ( jDownloadCart.length === 1 ) {
                            jDownloadCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                        }
                    }
                }, function ( data ) {
                    // console.log( data.cart.lastAdded[ 0 ].name, jQuery( '.js-e-products-item-' +
                    // data.cart.lastAdded[ 0 ].id ).attr( 'class' ) );
                    if ( data.cart.lastAdded.length !== 0 ) {
                        jQuery( '.js-e-products-item-' + data.cart.lastAdded[ 0 ].id ).addClass( 'is-in-cart' );
                        //                    console.log(data.cart.lastAdded[ 0 ].name, jQuery( '.js-e-products-item-'
                        // + data.cart.lastAdded[ 0 ].id ).attr('class'));
                    }
                    if ( jDownloadCart.length === 1 ) {
                        e4.download.cart.update( data );
                        jDownloadCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                        e4.download.orderline.focus( data.cart.lastAdded[ 0 ].id );
                    }
                    e4.download.cart.updateQuantity( data.cart.productLinesCount );
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                    e4.download.list.toogleIsInCart();
                    jDownloadCart.trigger( e4.download.event.added );
                } );
            //}
        },
        addMultipleProducts: function ( strObjProduct, fnCallback ) {
            var jDownloadCart = jQuery( '.js-e-download-cart' );
            jDownloadCart.trigger( e4.download.event.add );
            var objProductData = {
                OrderContext: 'ORDERCONTEXT1',
                CartCmd: 'addmulti',
                Redirect: false
            };
            if ( jQuery.isPlainObject( strObjProduct ) === true ) {
                jQuery.extend( objProductData, strObjProduct );
                e4.download.ajax( {
                    data: objProductData
                }, function ( data ) {
                    e4.download.cart.updateQuantity( data.cart.productLinesCount );
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                } );
            }
        },
        removeProduct: function ( strObjProduct, fnCallback ) {
            var objProductData = {
                OrderContext: 'ORDERCONTEXT1',
                CartCmd: 'delorderline',
                key: '',
                Redirect: false
            };
            if ( jQuery.isPlainObject( strObjProduct ) === true ) {
                jQuery.extend( objProductData, strObjProduct );
            }
            else if ( jQuery.type( strObjProduct ) === 'string' ) {
                objProductData.ProductID = strObjProduct;
            }
            if ( objProductData.ProductID.indexOf( 'PROD' ) === 0 ) {
                e4.download.ajax( {
                    method: 'GET'
                }, function ( data ) {
                    jQuery.each( data.cart.orderlines, function ( index, value ) {
                        if ( value.product.id === objProductData.ProductID ) {
                            objProductData.key = value.id;
                            if ( objProductData.key.indexOf( 'OL' ) === 0 ) {
                                e4.download.ajax( {
                                    method: 'GET',
                                    data: objProductData
                                }, function ( data ) {
                                    jQuery( '.js-e-products-item-' + objProductData.ProductID ).removeClass( 'is-in-cart' );
                                    e4.download.cart.updateQuantity( data.cart.productLinesCount );
                                    if ( typeof fnCallback === 'function' ) {
                                        fnCallback( data );
                                    }
                                } );
                                return false;
                            }
                        }
                    } );
                } );
            }
        },
        update: function ( data ) {
            var jDownloadCart = jQuery( '.js-e-download-cart' );
            jDownloadCart.trigger( e4.download.event.update );
            jQuery( '.js-e-download-cart-orderlines' ).html( e4.handlebars.tmpl.cartOrderlines( data ) );
            e4.loading.resolveWait( '.js-e-download-cart-orderlines' );
            e4.download.cart.updateQuantity( data.cart.productLinesCount );
            jDownloadCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            jDownloadCart.trigger( e4.download.event.updated );
        },
        updateQuantity: function ( intQuantity ) {
            if ( intQuantity === 0 ) {
                jQuery( '.js-e-download-cart-quantity' ).html( '' );
            }
            else if ( isNaN( parseInt( intQuantity ) ) === true ) {
                e4.download.ajax( {
                    method: 'GET'
                }, function ( data ) {
                    e4.download.cart.updateQuantity( data.cart.productLinesCount );
                } );
            }
            else {
                jQuery( '.js-e-download-cart-quantity' ).html( intQuantity );
            }
        },
        addEmail: function () {
            var jInputEmail = jQuery( '.js-e-download-cart-email' );
            jInputEmail.last().after( jInputEmail.first().clone().val( '' ) );
            jQuery( '.js-e-download-cart-email' ).last().trigger( 'focus' );
        }
    },
    orderline: {
        init: function () {
            // e4.download.orderline.event = e4.util.registerEvents( 'add added update updated delete deleted',
            // 'download' );
            e4.download.orderline.bindEvents();
        },
        bindEvents: function () {
            e4.download.cart.updateOrderlineTimeout = null;
            jQuery( '.js-e-download-cart-form' ).on( 'focus blur', '.js-e-orderline-quantity', function ( event ) {
                var jOrderline = jQuery( event.target ).closest( '.js-e-orderline' );
                if ( event.type === 'focusin' ) {
                    jQuery( event.target ).select();
                    jOrderline.addClass( 'has-focus' );
                }
                else {
                    jOrderline.removeClass( 'has-focus' );
                }
            } ).on( 'input', '.js-e-orderline-quantity', function ( event ) {
                if ( e4.download.cart.updateOrderlineTimeout !== null ) {
                    clearTimeout( e4.download.cart.updateOrderlineTimeout );
                    e4.download.cart.updateOrderlineTimeout = null;
                }
                e4.download.cart.updateOrderlineTimeout = setTimeout( function () {
                    if ( parseInt( event.target.value ) !== 0 && event.target.value !== '' ) {
                        e4.download.orderline.update( event.target );
                    }
                }, e4.settings.ecom.download.updateOrderlineDelay );
            } ).on( 'click', '.js-e-orderline-update', function ( event ) {
                event.preventDefault();
                e4.download.orderline.update( this );
            } ).on( 'click', '.js-e-orderline-delete', function ( event ) {
                event.preventDefault();
                e4.download.orderline.delete( this );
            } );
        },
        update: function ( domElm ) {
            var jDownloadCart        = jQuery( '.js-e-download-cart' ),
                jForm                = jQuery( domElm ).closest( '.js-e-download-cart-form' ),
                jOrderline           = jQuery( domElm ).closest( '.js-e-orderline' ),
                intOrderlineQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity' ).val() );
            if ( intOrderlineQuantity !== 0 ) {
                jForm.find( '.js-e-download-cart-form-cartcmd' ).val( 'updateorderlines' );
                e4.download.ajax( {
                    data: jForm.serialize(),
                    beforeSend: function () {
                        jDownloadCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    }
                }, function ( data ) {
                    e4.download.cart.update( data );
                    jDownloadCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                    e4.download.orderline.focus( jOrderline.attr( 'id' ) );
                } );
            }
            else {
                e4.download.orderline.delete( domElm );
            }
        },
        delete: function ( domElm ) {
            e4.download.ajax( {
                data: {
                    key: jQuery( domElm ).closest( '.js-e-orderline' ).attr( 'id' ),
                    OrderContext: 'ORDERCONTEXT1',
                    CartCmd: 'delorderline',
                    Redirect: false
                }
            }, function ( data ) {
                e4.download.cart.update( data );
            } );
        },
        focus: function ( strIdentifier ) {
            var jOrderline = jQuery( '.js-e-orderline' ).filter( '#' + strIdentifier + ',[data-product="' + strIdentifier + '"]' );
            if ( jOrderline.length === 1 ) {
                jOrderline.find( '.js-e-orderline-quantity' ).focus();
            }
        }
    }
};

